import { combineReducers, createStore, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { reducer as formReducer } from "redux-form";

import auth from "./auth";
import shops from "./shops";

let reducer = combineReducers({
	form: formReducer,
	auth,
	shops,
});

const store = createStore(
	reducer,
	composeWithDevTools(applyMiddleware(thunkMiddleware))
);

export default store;
